import React from 'react';
import { Cpu, HardDrive, Server, ShieldCheck, Activity, Terminal } from 'lucide-react';
import { TunnelStatus } from '../types';

interface SystemHealthViewProps {
  status: TunnelStatus | null;
}

export const SystemHealthView: React.FC<SystemHealthViewProps> = ({ status }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      <div className="metrics-row">
        <div className="metric-card">
          <div className="metric-header">
            <span>Operating System</span>
            <Server size={16} color="var(--accent-cyan)" />
          </div>
          <div className="metric-value" style={{ fontSize: '1.2rem', textTransform: 'capitalize' }}>
            {status?.platform || process.platform || 'Linux'}
          </div>
          <div className="metric-subtitle">Node.js {status?.nodeVersion || process.version}</div>
        </div>

        <div className="metric-card">
          <div className="metric-header">
            <span>SafeGuard AST Filter</span>
            <ShieldCheck size={16} color="var(--accent-green)" />
          </div>
          <div className="metric-value" style={{ color: 'var(--accent-green)', fontSize: '1.2rem' }}>
            Active (0 Bypass)
          </div>
          <div className="metric-subtitle">Lexer + Subcommand AST + SQL/Git Rules</div>
        </div>

        <div className="metric-card">
          <div className="metric-header">
            <span>Tunnel Protocol</span>
            <Activity size={16} color="var(--accent-blue)" />
          </div>
          <div className="metric-value" style={{ fontSize: '1.2rem' }}>
            WebSocket / AES-GCM
          </div>
          <div className="metric-subtitle">Outbound-only (Zero Open Ports)</div>
        </div>
      </div>

      <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border-subtle)', borderRadius: 'var(--radius-lg)', padding: '20px' }}>
        <h4 style={{ fontSize: '0.95rem', fontWeight: 700, marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Terminal size={16} color="var(--accent-cyan)" />
          Configured Workspace Roots
        </h4>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <div style={{ background: '#020617', padding: '10px 14px', borderRadius: 'var(--radius-md)', fontFamily: 'var(--font-mono)', fontSize: '0.85rem', color: 'var(--accent-cyan)' }}>
            Active Root: {status?.activeWorkspace || 'Current Workspace Directory'}
          </div>
        </div>
      </div>
    </div>
  );
};
